import React, { useState, useEffect } from "react";
import Preloader from "../../components/Preloader/Preloader";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Typography from "@material-ui/core/Typography";
import FormLabel from "@material-ui/core/FormLabel";
import MUIDataTable from "mui-datatables";
import { NavLink } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import MessageBox from "../../components/MessageBox/MessageBox";
import ButtonComponent from "react-button-component";
import LoadingOverlay from "react-loading-overlay";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";
import { get_cookies, isLoggedIn } from "../../components/Cookies/Cookies";
import numeral from "numeral";
import {
  MuiPickersUtilsProvider,
  KeyboardTimePicker,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import PopUpModal from "../../components/Modal/PopUpModal";
const useStyles = makeStyles((theme) => ({
  btnSearch: {
    // marginTop: 30,
    backgroundColor: "green",
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    maxWidth: "600px",
    margin: "0 auto",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    borderRadius:"5px",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: "800px",
  },
  field: {
    width: "100%",
    marginBottom: "1rem",
  },
}));
const WholesaleTransactionHistory = (props) => {
  const classes = useStyles();
  const [nextPagePath, setNextPagePath] = useState("");
  const [branchIdNo, setBranchIdNo] = useState(get_cookies("branchidno"));
  const [idnoselected, setIdnoSelected] = useState("");
  const [eligibleforrelease, setEligibleRel] = useState("");
  const [isFS, setIfFS] = useState("");
  const [isLoaded, setisLoaded] = useState();
  const [releaseidno, setReleaseIdno] = useState("");
  const [selectedpackagetype, setSelectedPackageType] = useState("");

  //Dropdown Filter
  const [hideDate, sethideDate] = useState(true);
  const [hideIdno, sethideIdno] = useState(false);
  const [hideRelStatus, sethideRelStatus] = useState(false);
  const [hideSoldto, sethideSoldto] = useState(false);
  const [hideActType, sethideActType] = useState(false);
  const [hideCountry, sethideCountry] = useState(false);
  const [hideDelTarget, sethideDelTarget] = useState(false);
  const [hidePackage, sethidePackage] = useState(false);
  const [hidePromo, sethidePromo] = useState(false);
  const [hidePackStatus, sethidePackStatus] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [messageType, setMessageType] = useState("info");
  const [popUpMessage, setPopUpMessage] = useState("");
   const [dateCheck, setDateCheck] = useState(null);
  //Dropdown Filter
  const min_releasedate = "2021-04-01";
  const nextpage = {
    // pathname: "/package-sales-payment",
    pathname: nextPagePath,
    idno: idnoselected,
    eligibleforrelease: eligibleforrelease,
    isfs: isFS,
  };
  const nextpageEncoding = {
    isCORelease: "yes",
  };
  const headers = {
    "Content-Type": "multipart/form-data",
    "Access-Control-Allow-Origin": process.env.REACT_APP_API_URL,
  };
  //ApiData Component useState SOF
  const get_accttype = () => {
    setisLoaded(true);
    //get data for warehouse/location dropdown
    const formData = new FormData();
    formData.append("form_data", "");
    const apiUrl = process.env.REACT_APP_API_URL + "accttypelist";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadAccttype(res.data.accttype);
    });
  };

  useEffect(() => {

}, [dateCheck]);

  const get_country = () => {
    //get data for shipping location dropdown
    const formData = new FormData();
    formData.append("form_data", "");
    const apiUrl = process.env.REACT_APP_API_URL + "countrylist";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadCountry(res.data.country);
    });
  };
    const check_if_release = async(idno) => {
    const form_data = {
      idno: idno,
    };
    //get data for shipping location dropdown
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl = process.env.REACT_APP_API_URL + "check_package_release";
    await axios.post(apiUrl, formData, { headers: headers }).then((res) => {
        if(res.data.data.releaseddate === "0000-00-00"){
            setDateCheck(true);
            return true;
        }else{
            setDateCheck(false);
              return false;
        }
      
      
    });
  };

  const get_packageavailed = () => {
    //get data for warehouse/location dropdown
    const form_data = {
      hqidno: branchIdNo,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl = process.env.REACT_APP_API_URL + "packageavailedlist";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadPackageAvailed(res.data.packageavailed);
    });
  };

  const package_sales_summary = () => {
    setisLoaded(false);
    //get data for warehouse/location dropdown
    const form_data = {
      hqidno: branchIdNo,
      prep_data: prep_data,
      country: get_cookies("country"),
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl = process.env.REACT_APP_API_URL + "wholesale_summary";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      loadPackageSalesList(res.data);
    });
  };

  const releasepackage = (idno) => {
    setShowOverlay(true);
    setOverlayMsg("Processing Release...");
    axios
      .get(process.env.REACT_APP_API_URL + "check_package", {
        params: {
          idno: idno,
          jc_u_idno: get_cookies("branchidno"),
        },
      })
      .then((res) => {
        const form_data2 = {
          package_obj: res.data.data,
          packageid: res.data.data[0].packageid,
          branchidno: branchIdNo,
        };

        const formData2 = new FormData();
        formData2.append("form_data", JSON.stringify(form_data2));
        const apiUrl = process.env.REACT_APP_API_URL + "checkiteminventory";
        axios.post(apiUrl, formData2, { headers: headers }).then((res) => {
          if (res.data.is_insufficient == "no") {
            const form_data = {
              hqidno: branchIdNo,
              idno: idno,
              username: get_cookies("username"),
            };
            const formData = new FormData();
            formData.append("form_data", JSON.stringify(form_data));
            const apiUrl = process.env.REACT_APP_API_URL + "releasewholesale";
            axios.post(apiUrl, formData, { headers: headers }).then((res) => {
              if (res.data.data.successful == 1) {
                setShowMsgBox(true);
                setMsg("Successfully Released Wholesale Set");
                setMsgType("success");
                setTimeout(() => {
                  setShowOverlay(false);
                  setOverlayMsg("");
                  setShowMsgBox(false);
                  package_sales_summary();
                }, 3000);
              } else {
                setShowOverlay(false);
                setShowMsgBox(true);
                setMsg(res.data.message);
                setMsgType("warning");
                setTimeout(() => {
                  setShowMsgBox(false);
                }, 3000);
              }
            });
          } else {
            setShowOverlay(false);
            setPopUpMessage(
              "Insufficient inventory quantity for the chosen Wholesale Set. You may contact our head office for your repurchase of products."
            );
            setModalOpen(true);
            setMessageType("warning");
            // console.log("no");
            setTimeout(() => {
              setModalOpen(false);
            }, 3000);
          }
        });
      })
      .catch((error) => {
        // console.log(error.message);
      });

    //get data for warehouse/location dropdown
  };

  const get_codesonly_details = (idno, packagetype) => {
    setShowOverlay(true);
    setOverlayMsg("Fetching Data...");
    //get data for warehouse/location dropdown
    const form_data = {
      idno: idno,
      packagetype: packagetype,
    };
    const formData = new FormData();
    formData.append("form_data", JSON.stringify(form_data));
    const apiUrl =
      process.env.REACT_APP_API_URL + "getcodesonlyencodingdetails";
    axios.post(apiUrl, formData, { headers: headers }).then((res) => {
      nextpageEncoding["pageInfo"] = res.data.pageInfo;
      nextpageEncoding["transactionInfo"] = res.data.transactionInfo;
      proceedtoencoding();
    });
  };
  //ApiData Component useState EOF
  const [accttype_dropdown, loadAccttype] = useState([]);
  const [country_dropdown, loadCountry] = useState([]);
  const [promocode_dropdown, loadPromocode] = useState([]);
  const [packageavailed_dropdown, loadPackageAvailed] = useState([]);

  const selectAccttypeProps = {
    options: accttype_dropdown,
    getOptionLabel: (option) => option.atype,
  };

  const selectCountryProps = {
    options: country_dropdown,
    getOptionLabel: (option) => option.countryname,
  };

  //Message Box
  const [showMsgBox, setShowMsgBox] = useState(false);
  const [msgBoxContent, setMsg] = useState("Empty");
  const [msgType, setMsgType] = useState("success");
  //Message Box EOF

  //Loading overlay
  const [showOverlay, setShowOverlay] = useState(false);
  const [overLayMsg, setOverlayMsg] = useState(false);
  //Loading overlay EOF

  //Table Settings
  const [TABLE_DATA, loadDataTable] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState({});

  const loadPackageSalesList = (data) => {
    refreshTable();
    const newData = [...TABLE_DATA];
    for (let i = 0; i < data.packagesalessummary.length; i++) {
      if (
        data.rawpackagesalessummary[i].status == 1 ||
        data.rawpackagesalessummary[i].status == 8 ||
        data.rawpackagesalessummary[i].status == 2 ||
        data.rawpackagesalessummary[i].status == 3 ||
        data.rawpackagesalessummary[i].status == 6
      ) {
        if (
          data.rawpackagesalessummary[i].releaseddate == "0000-00-00" &&
          data.rawpackagesalessummary[i].date >= min_releasedate
        ) {
          const tempObj = {
            trandate: data.packagesalessummary[i][0],
            soldto: data.packagesalessummary[i][1],
            idno: data.packagesalessummary[i][2],
            amount: data.packagesalessummary[i][3],
            packagetype: data.packagesalessummary[i][4],
            atype: data.packagesalessummary[i][5],
            action: (
              <Grid container spacing={2}>
                <Grid item xs={6} sm={6} xl={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      confirmrelease(
                        data.packagesalessummary[i][2],
                        data.rawpackagesalessummary[i].packageid,
                        data.packagesalessummary[i][4]
                      );
                    }}
                  >
                    Release
                  </Button>
                </Grid>
                <Grid item xs={6} sm={6} xl={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      viewpackagedetails(
                        data.packagesalessummary[i][2],
                        "yes",
                        ""
                      );
                    }}
                  >
                    View
                  </Button>
                </Grid>
              </Grid>
            ),
          };
          newData.push(tempObj);
        } else {
          const tempObj = {
            trandate: data.packagesalessummary[i][0],
            soldto: data.packagesalessummary[i][1],
            idno: data.packagesalessummary[i][2],
            amount: data.packagesalessummary[i][3],
            packagetype: data.packagesalessummary[i][4],
            atype: data.packagesalessummary[i][5],
            action: (
              <Grid container spacing={2}>
                <Grid item xs={6} sm={6} xl={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      viewpackagedetails(
                        data.packagesalessummary[i][2],
                        "no",
                        ""
                      );
                    }}
                  >
                    View
                  </Button>
                </Grid>
              </Grid>
            ),
          };
          newData.push(tempObj);
        }
      } else if (data.rawpackagesalessummary[i].status == 4) {
        if (data.rawpackagesalessummary[i].packageid == -1) {
          if (
            data.rawpackagesalessummary[i].releaseddate == "0000-00-00" &&
            data.rawpackagesalessummary[i].date >= min_releasedate
          ) {
            const tempObj = {
              trandate: data.packagesalessummary[i][0],
              soldto: data.packagesalessummary[i][1],
              idno: data.packagesalessummary[i][2],
              amount: data.packagesalessummary[i][3],
              packagetype: data.packagesalessummary[i][4],
              atype: data.packagesalessummary[i][5],
              action: (
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={6} xl={6}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) => {
                        confirmrelease(
                          data.packagesalessummary[i][2],
                          data.rawpackagesalessummary[i].packageid,
                          data.packagesalessummary[i][4]
                        );
                      }}
                    >
                      Release
                    </Button>
                  </Grid>
                  <Grid item xs={6} sm={6} xl={6}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) => {
                        viewpackagedetails(
                          data.packagesalessummary[i][2],
                          "yes",
                          ""
                        );
                      }}
                    >
                      View
                    </Button>
                  </Grid>
                </Grid>
              ),
            };
            newData.push(tempObj);
          } else {
            const tempObj = {
              trandate: data.packagesalessummary[i][0],
              soldto: data.packagesalessummary[i][1],
              idno: data.packagesalessummary[i][2],
              amount: data.packagesalessummary[i][3],
              packagetype: data.packagesalessummary[i][4],
              atype: data.packagesalessummary[i][5],
              action: (
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={6} xl={6}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) => {
                        viewpackagedetails(
                          data.packagesalessummary[i][2],
                          "no",
                          ""
                        );
                      }}
                    >
                      View
                    </Button>
                  </Grid>
                </Grid>
              ),
            };
            newData.push(tempObj);
          }
        } else {
          if (
            data.rawpackagesalessummary[i].releaseddate == "0000-00-00" &&
            data.rawpackagesalessummary[i].date >= min_releasedate
          ) {
            const tempObj = {
              trandate: data.packagesalessummary[i][0],
              soldto: data.packagesalessummary[i][1],
              idno: data.packagesalessummary[i][2],
              amount: data.packagesalessummary[i][3],
              packagetype: data.packagesalessummary[i][4],
              atype: data.packagesalessummary[i][5],
              action: (
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={6} xl={6}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) => {
                        confirmrelease(
                          data.packagesalessummary[i][2],
                          data.rawpackagesalessummary[i].packageid,
                          data.packagesalessummary[i][4]
                        );
                      }}
                    >
                      Release
                    </Button>
                  </Grid>
                  <Grid item xs={6} sm={6} xl={6}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) => {
                        viewpackagedetails(
                          data.packagesalessummary[i][2],
                          "yes",
                          "fs"
                        );
                      }}
                    >
                      View
                    </Button>
                  </Grid>
                </Grid>
              ),
            };
            newData.push(tempObj);
          } else {
            const tempObj = {
              trandate: data.packagesalessummary[i][0],
              soldto: data.packagesalessummary[i][1],
              idno: data.packagesalessummary[i][2],
              amount: data.packagesalessummary[i][3],
              packagetype: data.packagesalessummary[i][4],
              atype: data.packagesalessummary[i][5],
              action: (
                <Grid container spacing={2}>
                  <Grid item xs={6} sm={6} xl={6}>
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={(e) => {
                        viewpackagedetails(
                          data.packagesalessummary[i][2],
                          "yes",
                          "fs"
                        );
                      }}
                    >
                      View
                    </Button>
                  </Grid>
                </Grid>
              ),
            };
            newData.push(tempObj);
          }
        }
      } else if (data.rawpackagesalessummary[i].status == 5) {
        if (
          data.rawpackagesalessummary[i].releaseddate == "0000-00-00" &&
          data.rawpackagesalessummary[i].date >= min_releasedate
        ) {
          const tempObj = {
            trandate: data.packagesalessummary[i][0],
            soldto: data.packagesalessummary[i][1],
            idno: data.packagesalessummary[i][2],
            amount: data.packagesalessummary[i][3],
            packagetype: data.packagesalessummary[i][4],
            atype: data.packagesalessummary[i][5],
            action: (
              <Grid container spacing={2}>
                <Grid item xs={6} sm={6} xl={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      confirmrelease(
                        data.packagesalessummary[i][2],
                        data.rawpackagesalessummary[i].packageid,
                        data.packagesalessummary[i][4]
                      );
                    }}
                  >
                    Release
                  </Button>
                </Grid>
                <Grid item xs={6} sm={6} xl={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      viewpackagedetails(
                        data.packagesalessummary[i][2],
                        "yes",
                        ""
                      );
                    }}
                  >
                    View
                  </Button>
                </Grid>
              </Grid>
            ),
          };
          newData.push(tempObj);
        } else {
          const tempObj = {
            trandate: data.packagesalessummary[i][0],
            soldto: data.packagesalessummary[i][1],
            idno: data.packagesalessummary[i][2],
            amount: data.packagesalessummary[i][3],
            packagetype: data.packagesalessummary[i][4],
            atype: data.packagesalessummary[i][5],
            action: (
              <Grid container spacing={2}>
                <Grid item xs={6} sm={6} xl={6}>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={(e) => {
                      viewpackagedetails(
                        data.packagesalessummary[i][2],
                        "no",
                        ""
                      );
                    }}
                  >
                    View
                  </Button>
                </Grid>
              </Grid>
            ),
          };
          newData.push(tempObj);
        }
      }
    }
    loadDataTable([...newData]);
    setisLoaded(true);
  };

  const refreshTable = () => {
    TABLE_DATA.length = 0;
    const newData = [...TABLE_DATA];
    loadDataTable([...newData]);
  };

  const TABLE_COLUMNS = [
    {
      name: "trandate",
      label: "Date",
    },
    {
      name: "soldto",
      label: "Sold To",
    },
    {
      name: "idno",
      label: "ID No.",
    },
    {
      name: "amount",
      label: "Amount",
      options: {
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ textAlign: "right" }}>
              {numeral(value).format("0,0.00")}
            </div>
          );
        },
      },
    },
    {
      name: "atype",
      label: "Account Type",
    },
    {
      name: "packagetype",
      label: "Account Type Name",
    },
    {
      name: "action",
      label: "Action",
      options: {
        // setCellProps: () => (),
        customBodyRender: (data, type, row) => {
          return <pre>{data}</pre>;
        },
        filter: false,
        sort: false,
      },
    },
  ];

  const TABLE_OPTION = {
    selectableRows: "none",
  };
  //Table Settings EOF

  //Modal Settings
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleOpen2 = () => {
    setOpen2(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };
  //Modal Settings EOF
  const formatDate = (date) => {
    let d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  };
  //FormData
  const [prep_data, setData] = useState({
    startDate: formatDate(new Date()),
    endDate: formatDate(new Date()),
  });
  //FormData EOF
  //OnLoad Event/Data Fetching SOF
  useEffect(() => {
    isLoggedIn();
    get_country();
    get_accttype();
    package_sales_summary();
    clearState();
  }, []);
  //OnLoad Event/Data Fetching SOF

  // Date Picker
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const startDateChanged = (e) => {
    setStartDate(e);
    const newData = { ...prep_data };
    newData["startDate"] = formatDate(e);
    setData({ ...newData });
  };
  const endDateChanged = (e) => {
    setEndDate(e);
    const newData = { ...prep_data };
    newData["endDate"] = formatDate(e);
    setData({ ...newData });
  };

  const viewpackagedetails = (idno, eligible, fs) => {
    setNextPagePath("/wholesale-transaction-details/");
    setIdnoSelected(idno);
    if (eligible == "yes") {
      setEligibleRel("yes");
    } else {
      setEligibleRel("");
    }
    if (fs == "fs") {
      setIfFS("fs");
    } else {
      setIfFS("");
    }
    proceedtopackagedetails();
  };

  const set_package_encoding = () => {
    nextpageEncoding["pathname"] = "/package-sales-information";
    get_codesonly_details(releaseidno, selectedpackagetype + "SET");
  };

  const cyop_encoding = () => {
    nextpageEncoding["pathname"] = "/package-sales-item";
    get_codesonly_details(releaseidno, selectedpackagetype + "CYOP");
  };

  useEffect(() => {
    props.history.push(nextpage);
  }, [nextPagePath]);

  const proceedtopackagedetails = () => {
    props.history.push(nextpage);
  };

  const proceedtoencoding = () => {
    props.history.push(nextpageEncoding);
  };

  const confirmrelease =  async (idno, packageid, packagetype) => {
    setReleaseIdno(idno);
    setSelectedPackageType(packagetype);
    
   await check_if_release(idno);

    if (packageid == 0) {
      handleOpen2();
    } else {
      handleOpen();
    }
  };
  const prepData_initialState = {
    idno_filter: "",
    relstats_filter: "",
    soldto_filter: "",
    accttype_filter: "",
    country_filter: "",
    delivery_filter: "",
    packstats_filter: "",
    startDate: formatDate(new Date()),
    endDate: formatDate(new Date()),
  };

  const clearState = () => {
    setData({ ...prepData_initialState });
  };
  //Dropdown Filter Value
  const filterList = [
    { description: "Transaction Date", id: "date_filter" },
    { description: "IDNO", id: "idno_filter" },
    { description: "Release Status", id: "relstats_filter" },
    { description: "Sold To", id: "soldto_filter" },
    { description: "Activation Type", id: "accttype_filter" },
    { description: "Delivery Type", id: "delivery_filter" },
    { description: "Package Status", id: "packstats_filter" },
  ];
  const releaseStatusList = [
    { description: "All", id: "" },
    { description: "For Release", id: 2 },
    { description: "Released", id: 1 },
  ];
  const deliveryList = [
    { description: "All", id: "" },
    { description: "Pick Up", id: 1 },
    { description: "Delivery", id: 2 },
    { description: "Toktok", id: 30 },
  ];
  const display_filters = (a, b, c, d, e, f, g, h, i, j) => {
    sethideDate(a);
    sethideIdno(b);
    sethideRelStatus(c);
    sethideSoldto(d);
    sethideActType(e);
    sethideCountry(f);
    sethideDelTarget(g);
    sethidePackage(h);
    sethidePromo(i);
    sethidePackStatus(j);
  };
  const clearStateSpecific = (nametoclear) => {
    const newData = { ...prep_data };
    newData[nametoclear] = "";
    setData({ ...newData });
  };
  const onFilterChange = (selectedFilter) => {
    //clear prep_data value if not selected
    clearState();
    setStartDate(new Date());
    setEndDate(new Date());
    switch (selectedFilter) {
      case "date_filter":
        display_filters(
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false
        );
        break;
      case "idno_filter":
        display_filters(
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false
        );
        break;
      case "relstats_filter":
        display_filters(
          true,
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false
        );
        break;
      case "soldto_filter":
        display_filters(
          true,
          false,
          false,
          true,
          false,
          false,
          false,
          false,
          false,
          false
        );
        break;
      case "country_filter":
        display_filters(
          false,
          false,
          false,
          false,
          false,
          true,
          false,
          false,
          false,
          false
        );
        break;
      case "delivery_filter":
        display_filters(
          true,
          false,
          false,
          false,
          false,
          false,
          true,
          false,
          false,
          false
        );
        break;
      case "package_filter":
        display_filters(
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          true,
          false,
          false
        );
        break;
      case "packstats_filter":
        display_filters(
          true,
          false,
          false,
          false,
          false,
          false,
          true,
          true,
          true,
          true
        );
        break;

      default:
        display_filters(
          true,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false,
          false
        );
        break;
    }
  };

  const onInputChange = (event) => {
    const newData = { ...prep_data };
    newData[event.target.name] = event.target.value;
    setData({ ...newData });
  };
  //Date Picker EOF
  return (
    <div className="page">
      <LoadingOverlay active={showOverlay} spinner text={overLayMsg}>
        <PopUpModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          message={popUpMessage}
          type={messageType}
        />
        <div className="page-header">
          <div className="page-icon">
            <LoyaltyTwoTone />
          </div>
          <Breadcrumbs aria-label="breadcrumb">
            <NavLink to="/wholesale-transaction-history/">
              <h4 className="header-title">Wholesale Set</h4>
            </NavLink>
            <Typography color="textPrimary">
              Wholesale Set Transaction History
            </Typography>
          </Breadcrumbs>
        </div>
        <MessageBox in={showMsgBox} content={msgBoxContent} type={msgType} />
        <div className="page-container">
          <Grid container spacing={4} style={{ alignItems: "center" }}>
            <Grid item xs={12} sm={3}>
              <Autocomplete
                autoComplete
                options={filterList}
                getOptionLabel={(option) => option.description}
                includeInputInList
                className={classes.autoComplete}
                name="filterList"
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Filters"
                    margin="normal"
                    variant="outlined"
                  />
                )}
                onChange={(event, newValue) => {
                  if (!newValue == "" || !newValue == null) {
                    onFilterChange(newValue.id);
                  }
                }}
              />
            </Grid>
            <MuiPickersUtilsProvider utils={DateFnsUtils}>
              {hideDate ? (
                <Grid item xs={12} sm={2}>
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    name="startDate"
                    label="From"
                    value={startDate}
                    inputVariant="outlined"
                    margin="normal"
                    required="true"
                    onChange={startDateChanged}
                    shouldCloseOnSelect={true}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </Grid>
              ) : null}
              {hideDate ? (
                <Grid item xs={12} sm={2}>
                  <KeyboardDatePicker
                    disableToolbar
                    variant="inline"
                    format="MM/dd/yyyy"
                    name="endDate"
                    label="To"
                    value={endDate}
                    inputVariant="outlined"
                    margin="normal"
                    required="true"
                    shouldCloseOnSelect={true}
                    onChange={endDateChanged}
                    KeyboardButtonProps={{
                      "aria-label": "change date",
                    }}
                  />
                </Grid>
              ) : null}
            </MuiPickersUtilsProvider>
            {hideIdno ? (
              <Grid item xs={12} sm={3}>
                <TextField
                  name="idno_filter"
                  label="IDNO"
                  variant="outlined"
                  type="text"
                  margin="normal"
                  className={classes.field}
                  onChange={onInputChange}
                />
              </Grid>
            ) : null}
            {hideRelStatus ? (
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  name="relstats_filter"
                  autoComplete
                  options={releaseStatusList}
                  getOptionLabel={(option) => option.description}
                  includeInputInList
                  className={classes.autoComplete}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Release Status"
                      margin="normal"
                      variant="outlined"
                    />
                  )}
                  onChange={async (event, newValue) => {
                    if (!newValue == "" || !newValue == null) {
                      //code here
                      const newData = {
                        ...prep_data,
                      };
                      newData["relstats_filter"] = newValue.id;
                      setData({ ...newData });
                    } else {
                      clearStateSpecific("relstats_filter");
                    }
                  }}
                />
              </Grid>
            ) : null}
            {hideSoldto ? (
              <Grid item xs={12} sm={3}>
                <TextField
                  name="soldto_filter"
                  label="Sold To"
                  variant="outlined"
                  type="text"
                  margin="normal"
                  className={classes.field}
                  onChange={onInputChange}
                />
              </Grid>
            ) : null}
            {hideActType ? (
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  {...selectAccttypeProps}
                  autoComplete
                  includeInputInList
                  className={classes.autoComplete}
                  name="accttype_filter"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Activation Type"
                      margin="normal"
                      variant="outlined"
                      required="true"
                    />
                  )}
                  onChange={async (event, newValue) => {
                    if (!newValue == "" || !newValue == null) {
                      const newData = {
                        ...prep_data,
                      };
                      newData["accttype_filter"] = newValue.atype;
                      setData({ ...newData });
                    } else {
                      clearStateSpecific("accttype_filter");
                    }
                  }}
                />
              </Grid>
            ) : null}
            {hideCountry ? (
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  {...selectCountryProps}
                  autoComplete
                  includeInputInList
                  className={classes.autoComplete}
                  name="country_filter"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Country"
                      margin="normal"
                      variant="outlined"
                      required="true"
                    />
                  )}
                  onChange={async (event, newValue) => {
                    if (!newValue == "" || !newValue == null) {
                      const newData = {
                        ...prep_data,
                      };
                      newData["country_filter"] = newValue.countryname;
                      setData({ ...newData });
                    } else {
                      clearStateSpecific("country_filter");
                    }
                  }}
                />
              </Grid>
            ) : null}
            {hideDelTarget ? (
              <Grid item xs={12} sm={3}>
                <Autocomplete
                  name="delivery_filter"
                  autoComplete
                  options={deliveryList}
                  getOptionLabel={(option) => option.description}
                  includeInputInList
                  className={classes.autoComplete}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Delivery Type"
                      margin="normal"
                      variant="outlined"
                    />
                  )}
                  onChange={async (event, newValue) => {
                    if (!newValue == "" || !newValue == null) {
                      //code here
                      const newData = {
                        ...prep_data,
                      };
                      newData["delivery_filter"] = JSON.stringify(
                        newValue.id,
                        null,
                        " "
                      );
                      setData({ ...newData });
                    } else {
                      clearStateSpecific("delivery_filter");
                    }
                  }}
                />
              </Grid>
            ) : null}

            <Grid item xs={12} sm={1}>
              <Button
                variant="contained"
                color="primary"
                className={classes.btnSearch}
                onClick={(e) => {
                  package_sales_summary();
                }}
              >
                Search
              </Button>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ marginTop: "10px" }}>
            {!isLoaded ? (
              <Preloader />
            ) : (
              <MUIDataTable
                title={
                  <div>
                    <div className="table-title">
                      Wholesale Set Transaction History
                    </div>
                  </div>
                }
                id="table-grid"
                data={TABLE_DATA}
                columns={TABLE_COLUMNS}
                options={TABLE_OPTION}
              />
            )}
          </Grid>
        </div>
      </LoadingOverlay>
      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
<Fade in={open}>
  <div className={classes.paper}>
    <h4 id="transition-modal-title">System Message</h4>
    <form action="" className={classes.root}>
      {/* Warning messages, only if dateCheck is true */}
      {dateCheck && (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div style={{ color: 'red', fontWeight: 'bold' }}>
              Items for this IDNO have not yet been released by headquarters.
            </div>
          </Grid>
          <Grid item xs={12}>
            <div>
              Proceeding now will consume your current inventory.
            </div>
          </Grid>
        </Grid>
      )}

      {/* Confirmation question, always shown */}
      <Grid container spacing={2} style={{ marginTop: 16 }}>
        <Grid item xs={12}>
          Are you sure you want to release this set?
        </Grid>
      </Grid>

      {/* Buttons */}
      <div className={classes.button} style={{ marginTop: 16 }}>
        <Grid container spacing={2}>
          <Grid item>
            <Button
              variant="contained"
              onClick={handleClose}
              className={classes.buttonMarginRight}
            >
              No
            </Button>
          </Grid>
          <Grid item>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                releasepackage(releaseidno);
                handleClose();
              }}
            >
              Yes
            </Button>
          </Grid>
        </Grid>
      </div>
    </form>
  </div>
</Fade>

        </Modal>
      </div>
      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open2}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Fade in={open2}>
            <div className={classes.paper}>
              <h4 id="transition-modal-title">
                Choose Transaction First to Proceed
              </h4>
              <form action="" className={classes.root}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Button
                      variant="contained"
                      className={classes.buttonMarginRight}
                      onClick={set_package_encoding}
                    >
                      Set Package
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      variant="contained"
                      className={classes.buttonMarginRight}
                      onClick={cyop_encoding}
                    >
                      Choose Your Own Package
                    </Button>
                  </Grid>
                </Grid>
                <div className={classes.button}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={12}>
                      <Button
                        variant="contained"
                        onClick={handleClose2}
                        className={classes.buttonMarginRight}
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          float: "right",
                          marginTop: "10px",
                        }}
                      >
                        Cancel
                      </Button>
                    </Grid>
                  </Grid>
                </div>
              </form>
            </div>
          </Fade>
        </Modal>
      </div>
    </div>
  );
};

export default WholesaleTransactionHistory;
